/* eslint-disable require-jsdoc */
import moment from 'moment';
import 'moment-timezone';
import jstz from 'jstz';


const ensuringCorrectYear = (utcTimeData) => {
  const timezone = jstz.determine();
  const userTimeZone = timezone.name();
  // console.log('user"s curent time zone: ', userTimeZone);
  const eventInUserTimeAndZone =
      moment.utc(utcTimeData).tz(userTimeZone).format('yyyy');
  // console.log('when show happens in user"s time: ',
  //     eventInUserTimeAndZone);
  return eventInUserTimeAndZone;
};

export default ensuringCorrectYear;
